'use strict';

// One browser contract for Pug, the web bootstrap and React. This record is
// analytics-only: it never reads or changes authentication/session cookies.
// Keep the installer self-contained; the same function is serialized into HTML.
function installWebAnalytics(scope, installLinks) {
  if (scope.__gabWebAnalytics) {
    if (installLinks) scope.__gabWebAnalytics.installLinks = installLinks;
    return scope.__gabWebAnalytics;
  }
  var storageKey = 'gab.analytics.visit.v1';
  var timeout = 30 * 60 * 1000;
  var memory = null;
  var reportedPath = null;

  function enabled() {
    var loc = scope.location;
    return !!(loc && loc.protocol === 'https:' && !loc.port &&
      /^(?:www\.)?gab\.ai$/i.test(loc.hostname) &&
      !/^\/(?:__preview|__public-preview|reports)(?:\/|$)/.test(loc.pathname));
  }

  function path() {
    var value = scope.location.pathname || '/';
    if (!/^\/(?!\/)/.test(value) || /[?#\\\u0000-\u0020]/.test(value) || value.length > 2048) return '/';
    // The acquisition dimension does not need private conversation/task IDs.
    if (/^\/(?:app|c|chat|work|settings)(?:\/|$)/.test(value)) return '/' + value.split('/')[1];
    return value;
  }

  function day(now) {
    // Matches Site 1's inspected reporting timezone, including DST.
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
  }

  function campaign() {
    var params = new URLSearchParams(scope.location.search || '');
    var pairs = [];
    params.forEach(function (value, key) {
      if (/^(?:utm_(?:source|medium|campaign|id|term|content)|mtm_(?:source|medium|campaign|keyword|content|cid|group|placement)|pk_(?:campaign|kwd)|gclid|dclid|msclkid|fbclid|rdt_cid)$/.test(key)) pairs.push(key + '=' + value);
    });
    if (!pairs.length) return '';
    // An equality signature, not an identifier or security primitive. Do not
    // persist raw campaign/click parameters, prompts, referrals or URL queries.
    var text = pairs.sort().join('&'), a = 2166136261, b = 5381;
    for (var i = 0; i < text.length; i++) { a = Math.imul(a ^ text.charCodeAt(i), 16777619); b = Math.imul(b, 33) ^ text.charCodeAt(i); }
    return (a >>> 0).toString(16) + ':' + (b >>> 0).toString(16);
  }

  function internalReferrer() {
    try { return new URL(scope.document.referrer).origin === scope.location.origin; }
    catch (_) { return false; }
  }

  function touch() {
    if (!enabled()) return null;
    var now = Date.now(), today = day(now), currentCampaign = campaign();
    var previous = memory, writable = true;
    var raw = null;
    try { raw = scope.localStorage.getItem(storageKey); } catch (_) { writable = false; }
    try {
      var saved = raw && JSON.parse(raw);
      if (saved && (!previous || saved.updatedAt >= previous.updatedAt)) previous = saved;
    } catch (_) { /* Ignore a damaged analytics record. */ }
    var valid = previous && previous.version === 1 && typeof previous.landingPath === 'string' &&
      /^\/(?!\/)[^?#\\\u0000-\u0020]*$/.test(previous.landingPath) && previous.landingPath.length <= 2048 &&
      Number.isFinite(previous.updatedAt) && previous.updatedAt <= now && now - previous.updatedAt < timeout &&
      typeof previous.campaign === 'string' && /^(?:[a-f0-9]+:[a-f0-9]+)?$/.test(previous.campaign) &&
      previous.day === today && (!currentCampaign || currentCampaign === previous.campaign);
    var record = { version: 1, landingPath: valid ? previous.landingPath : path(), updatedAt: now,
      day: today, campaign: currentCampaign || (valid ? previous.campaign : '') };
    try { if (writable) scope.localStorage.setItem(storageKey, JSON.stringify(record)); }
    catch (_) { writable = false; }
    // With unavailable storage, retain document memory. On a later internal
    // document, leave an unknown original dimension alone instead of replacing
    // it with signup/app. Matomo's built-in entry-page report remains available.
    if (!writable && !previous && !currentCampaign && internalReferrer()) return null;
    memory = record;
    return record.landingPath;
  }

  function withLanding(queue) {
    if (!enabled() || !queue || typeof queue.push !== 'function') return null;
    var landing = touch();
    if (landing && landing !== reportedPath) {
      queue.push(['setCustomDimension', 3, landing]);
      reportedPath = landing;
    }
    return queue;
  }

  scope.__gabWebAnalytics = { enabled: enabled, touch: touch, withLanding: withLanding, installLinks: installLinks || {} };
  return scope.__gabWebAnalytics;
}

const { APP_STORE_URL, GOOGLE_PLAY_URL, MICROSOFT_STORE_URL } = require('../constants/appStoreLinks');
const installLinks = { ios: APP_STORE_URL, android: GOOGLE_PLAY_URL, windows: MICROSOFT_STORE_URL,
  extension: require('../constants/browserExtensionRelease.json').storeURL };
const WEB_ANALYTICS_BOOT_SCRIPT = '(' + installWebAnalytics.toString() + ')(window,' + JSON.stringify(installLinks).replace(/</g, '\\u003c') + ');';
module.exports = { installWebAnalytics, WEB_ANALYTICS_BOOT_SCRIPT };
